import { call, put, takeLatest } from 'redux-saga/effects'
import { FetchRemoteConfig } from 'src/constants/actionTypes'
import { Endpoints } from 'src/constants/endpoints'
import type { RemoteConfigResponse, RemoteConfigValues } from 'src/interfaces/remoteConfig'
import { AsyncAction } from 'src/utils/reduxUtils'
import { captureSentryError } from 'src/utils/sentry'
import { callSecureApi } from './api/callApi'

function* onFetchRemoteConfig(action: AsyncAction<void, RemoteConfigValues>) {
  try {
    const { payload }: { payload: RemoteConfigResponse } = yield call(
      callSecureApi,
      Endpoints.FetchRemoteConfig,
    )

    const values = payload?.values ?? {}

    yield put(FetchRemoteConfig.success(values))

    if (action.next) {
      action.next(null, values)
    }
  } catch (err: any) {
    captureSentryError(err, { message: '[saga.remoteConfig.onFetchRemoteConfig] error' })

    yield put(FetchRemoteConfig.failed(err))

    if (action.next) {
      action.next('Failed to load remote config')
    }
  }
}

export function* remoteConfigSaga() {
  yield takeLatest(FetchRemoteConfig.type.REQUEST, onFetchRemoteConfig)
}
